import { Tooltip } from "@brg/ui";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const PrivateCollectionIconWrapepr = styled.div`
    display: flex;
    position: absolute;
    bottom: 70px;
    right: calc(100% - 16px - 40px);
    padding: 4px 8px;
    border-radius: 4px;
    background: rgba(24, 26, 28, 0.45);
    backdrop-filter: blur(2px);
    width: 40px;
    height: 32px;
    align-items: center;
    justify-content: center;
`

const PrivateCollectionTooltip = styled.div`
    display: flex;
    justify-content: center;
    padding: 4px 8px;
    color: #70706F;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    border-radius: 6px;
    background: #E7E7E7;
    gap: 4px;
`

const PrivateCollectionIcon = memo(() => {

    const { t } = useTranslation() 

    return <PrivateCollectionIconWrapepr>
                <Tooltip
                    // visible={true}
                    target={<svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99902 0.299805C12.6307 0.299805 14.7617 2.39572 14.7617 4.95801V9.1123H16.751C18.1361 9.1123 19.2637 10.2399 19.2637 11.625V21.1875C19.2637 22.5726 18.1361 23.7002 16.751 23.7002H3.25098C1.86585 23.7002 0.738281 22.5726 0.738281 21.1875V11.625C0.738281 10.2399 1.86585 9.1123 3.25098 9.1123H5.23633V4.95801C5.23633 2.39579 7.36742 0.299921 9.99902 0.299805ZM3.25098 10.3877C2.56835 10.3877 2.01367 10.9424 2.01367 11.625V21.1875C2.01367 21.8701 2.56835 22.4248 3.25098 22.4248H16.751C17.4336 22.4248 17.9883 21.8701 17.9883 21.1875V11.625C17.9883 10.9424 17.4336 10.3877 16.751 10.3877H3.25098ZM9.99902 1.5752C8.08537 1.57531 6.51172 3.08307 6.51172 4.95801V9.1123H13.4863V4.95801C13.4863 3.083 11.9128 1.5752 9.99902 1.5752Z" fill="#E7E7E7"/>
                            </svg>
                    }
                    placement="top"
                    offset={[0, 4]}
                >       
                    <PrivateCollectionTooltip>{t('project_edit.modal.collection.private_collection_tooltip')}</PrivateCollectionTooltip>  
                </Tooltip>
            </PrivateCollectionIconWrapepr>
})

export default PrivateCollectionIconimport { Tooltip } from "@brg/ui";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const PrivateCollectionIconWrapepr = styled.div`
    display: flex;
    position: absolute;
    bottom: 70px;
    right: calc(100% - 16px - 40px);
    padding: 4px 8px;
    border-radius: 4px;
    background: rgba(24, 26, 28, 0.45);
    backdrop-filter: blur(2px);
    width: 40px;
    height: 32px;
    align-items: center;
    justify-content: center;
`

const PrivateCollectionTooltip = styled.div`
    display: flex;
    justify-content: center;
    padding: 4px 8px;
    color: #70706F;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    border-radius: 6px;
    background: #E7E7E7;
    gap: 4px;
`

const PrivateCollectionIcon = memo(() => {

    const { t } = useTranslation() 

    return <PrivateCollectionIconWrapepr>
                <Tooltip
                    // visible={true}
                    target={<svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99902 0.299805C12.6307 0.299805 14.7617 2.39572 14.7617 4.95801V9.1123H16.751C18.1361 9.1123 19.2637 10.2399 19.2637 11.625V21.1875C19.2637 22.5726 18.1361 23.7002 16.751 23.7002H3.25098C1.86585 23.7002 0.738281 22.5726 0.738281 21.1875V11.625C0.738281 10.2399 1.86585 9.1123 3.25098 9.1123H5.23633V4.95801C5.23633 2.39579 7.36742 0.299921 9.99902 0.299805ZM3.25098 10.3877C2.56835 10.3877 2.01367 10.9424 2.01367 11.625V21.1875C2.01367 21.8701 2.56835 22.4248 3.25098 22.4248H16.751C17.4336 22.4248 17.9883 21.8701 17.9883 21.1875V11.625C17.9883 10.9424 17.4336 10.3877 16.751 10.3877H3.25098ZM9.99902 1.5752C8.08537 1.57531 6.51172 3.08307 6.51172 4.95801V9.1123H13.4863V4.95801C13.4863 3.083 11.9128 1.5752 9.99902 1.5752Z" fill="#E7E7E7"/>
                            </svg>
                    }
                    placement="top"
                    offset={[0, 4]}
                >       
                    <PrivateCollectionTooltip>{t('project_edit.modal.collection.private_collection_tooltip')}</PrivateCollectionTooltip>  
                </Tooltip>
            </PrivateCollectionIconWrapepr>
})

export default PrivateCollectionIcon